import React, { useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { Checkbox, Icon, Dropdown } from "semantic-ui-react";
import { navActions } from "./../../../../redux/nav";
import { filterActions } from "./../../../../redux/filters";
import { benchmarksOperations } from "../../../../redux/benchmarks"
import { Wrapper, BenchmarkContainer, BenchmarkIcon } from "./style.js";
import IconButton from "./../../../../components/IconButton";
import TextField from "@material-ui/core/TextField";
import { getFilterUrlPart } from "../../../../lib/utils";
import Select from "../../../../components/Select";
import TypographyParagraph from "../../../../components/TypographyParagraph";
import FiltersErrorDialog from "../FiltersErrorDialog";
import clsx from "clsx";
import _ from "lodash";
import axios from "axios";
import { useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { getBenchmarkLabel } from "../../../../lib/utils";

const getFilterValues = (data, key) => (data && Array.isArray(data[key]) ? data[key].map((a) => ({ _id: a, value: a })) : []);

const FilterSelect = (key, label, column, options, selected, setValueFn) => {
  return (
    <React.Fragment key={key}>
      <div className="label">{label}</div>  
      <Select
        multiple
        chipLimit={1}
        chipCharacterLimit={12}
        addOption={(optionId) => setValueFn(column, [...selected, optionId])}
        removeOption={(optionId) => setValueFn(column, [...selected.filter((id) => id !== optionId)])}
        selectedIds={selected}
        selectableOptions={options}
      />      
    </React.Fragment>
  )
}

function Sidebar(props) {
  const {
    summaryReport,
    toggleShowInlineValuesOnDonuts,
    toggleShowAllQuestions,
    toggleShowAllQuestionInlineValues,
    showInlineValuesOnDonuts,
    showAllQuestions,
    showAllQuestionInlineValues,
    unit,
    nav,
    dispatch,
    configuration,
    appliedBenchmark
  } = props;


  const [showFiltersError, setShowFiltersError] = useState(false);
  const [ageFilter, setAgeFilter] = useState(props.filters.age);
  const [raceFilter, setRaceFilter] = useState(props.filters.race);
  const [genderFilter, setGenderFilter] = useState(props.filters.gender);
  const [jobFilter, setJobFilter] = useState(props.filters.job);
  const [timeFilter, setTimeFilter] = useState(props.filters.time);
  const [shiftFilter, setShiftFilter] = useState(props.filters.shift);
  const [workerFilter, setWorkerFilter] = useState(props.filters.worker);
  const [summary, setSummary] = useState('');
  const [title, setTitle] = useState('');
  const [showSummaryEdit, setShowSummaryEdit] = useState(false);
  const [hasEdited, setHasEdited] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [locationFilter, setLocationFilter] = useState(props.filters.location);
  const [hrFilter, setHrFilter] = useState(props.filters.hr);
  const [companyFilter, setCompanyFilter] = useState(props.filters.company);
  const [costFilter, setCostFilter] = useState([]);
  const [costNameFilter, setCostNameFilter] = useState([]);
  const [backupFilter, setBackupFilter] = useState([]);

  const [ethnicityFilter, setEthnicityFilter] = useState(props.filters.ethnicity);
  const [veteranFilter, setVeteranFilter] = useState(props.filters.veteran);

  const [employmentFilter, setEmploymentFilter] = useState(props.filters.employment);
  const [specialtyFilter, setspecialtyFilter] = useState(props.filters.specialty);

  const [unitFilter, setUnitFilter] = useState(props.filters.unit);
  const [positionFilter, setPositionFilter] = useState(props.filters.position);

  const [locFilter, setLocFilter] = useState(props.filters.loc);

  const [otherFilters, setOtherFilters] = useState(props.filters.otherFilters);

  const anyFiltersSet = () => 
    ageFilter.length > 0 ||
    raceFilter.length > 0 ||
    genderFilter.length > 0 ||
    jobFilter.length > 0 ||
    timeFilter.length > 0 ||
    shiftFilter.length > 0 ||
    workerFilter.length > 0 ||
    locationFilter.length > 0 ||
    hrFilter.length > 0 ||
    costFilter.length > 0 ||
    costNameFilter.length > 0 ||
    backupFilter.length > 0 ||
    companyFilter.length > 0 ||
    veteranFilter.length > 0 ||
    ethnicityFilter.length > 0 ||
    employmentFilter.length > 0 ||
    specialtyFilter.length > 0 ||
    unitFilter.length > 0 ||
    positionFilter.length > 0 ||
    locFilter.length > 0 || 
    Object.keys(otherFilters).length > 0;

  const openSettings = () => {
    dispatch(navActions.openSettings());
  };

  const closeSettings = () => {
    dispatch(navActions.closeSettings());
  };

  const clearFilters = () => {
    setAgeFilter([]);
    setRaceFilter([]);
    setGenderFilter([]);
    setJobFilter([]);
    setTimeFilter([]);
    setShiftFilter([]);
    setWorkerFilter([]);
    setSummary('');
    setTitle('');
    setShowSummaryEdit(false);
    setHasEdited(false);
    setLocationFilter([]);
    setHrFilter([]);
    setCompanyFilter([]);
    setCostFilter([]);
    setCostNameFilter([]);
    setBackupFilter([]);
    setVeteranFilter([]);
    setEthnicityFilter([])
    setEmploymentFilter([]);
    setspecialtyFilter([]);
    setUnitFilter([]);
    setPositionFilter([]);
    setLocFilter([]);
    setOtherFilters({});

    if (props.filters.count >= 0) {
      dispatch(navActions.closeSettings());
      dispatch(filterActions.clearFilters());
    }
  }


  const setOtherFilterValues = (column, ids) => {
    let newFilters = {...otherFilters};
    newFilters[column] = ids;
    setOtherFilters(newFilters);
  }

  const hasOtherFilters = () => {
    if (!configuration || !configuration.filters) return false;
    if (!Array.isArray(configuration.filters)) return false;
    
    return true;
  }

  const showOtherFilters = () => {
    const { filterValues } = summaryReport;

    if (!hasOtherFilters()) return;
  
    return configuration.filters.map( (filter, index) => FilterSelect(
      index,
      filter.title,
      filter.column,
      getFilterValues(filterValues, filter.column),
      otherFilters[filter.column] || [],
      setOtherFilterValues
    ))
  
  }  

  const getFilterSummary = (filters, otherFilters) => {
    const titles = {
      ageFilter: 'Age',
      raceFilter: 'Race',
      genderFilter: 'Gender',
      jobFilter: 'Job Family',
      timeFilter: 'Full/Part time',
      shiftFilter: 'Work Shift',
      workerFilter: 'Worker Sub Type',
  
      locationFilter: 'Location Hierarchy',
      hrFilter: 'HR Company Name',
      companyFilter: 'Company',
      costFilter: 'Cost Center',
      costNameFilter: 'Cost Center Name',
      backupFilter: 'Team Name',
  
      ethnicityFilter: 'Ethnicity',
      veteranFilter: 'Veteran Status',
  
      employmentFilter: 'Employment',
      specialtyFilter: 'Specialty',
  
      unitFilter: 'Work Setting',
      positionFilter: 'Position',
      locFilter: 'Location'
  
    }
  
    const base_summary = Object.keys(titles)
      .filter( key => Array.isArray(filters[key]) && filters[key].length > 0)
      .map( key => `${titles[key]} (${filters[key].join(', ')})`);

    const other_summary = Object.keys(otherFilters)
      .map( key => configuration.filters.find(f => f.column === key))
      .map( config => `${config.title} (${otherFilters[config.column].join(', ')})`);

    return [...base_summary, ...other_summary].join('; ');
  }

  const applyFilters = () => {
    const { summaryReport } = props;
    const filters = {
      age: ageFilter,
      race: raceFilter,
      gender: genderFilter,
      job: jobFilter,
      time: timeFilter,
      shift: shiftFilter,
      worker: workerFilter,
      location: locationFilter,
      hr: hrFilter,
      company: companyFilter, 
      cc: costFilter,
      ccn: costNameFilter,
      backup: backupFilter,
      veteran: veteranFilter,
      ethnicity: ethnicityFilter,
      specialty: specialtyFilter,
      employment: employmentFilter,
      unit: unitFilter,
      position: positionFilter,
      loc: locFilter
    };

    const filterParams = getFilterUrlPart(filters, otherFilters, configuration);

    const all_filters = {
      ...filters, 
      otherFilters
    }

    setSubmitting(true);
    axios
      .get(`/api/filters/${summaryReport.datasetId}_${summaryReport.resultSetId}/count?unit=${unit}${filterParams}`)
      .then((res) => {
        setSubmitting(false);
        if (res && res.data && parseInt(res.data.count, 10) >= 5) {
          dispatch(navActions.closeSettings());
          dispatch(filterActions.setFilters({...all_filters, count: res.data.count, summary: title || summary}));
        } else {
          toggleShowFiltersError();
        }
      })
      .catch(ex => {
        setSubmitting(false);
      });
  };

  const toggleShowFiltersError = () => {
    setShowFiltersError(!showFiltersError);
  };
  
  useEffect(() => {
    const summary = getFilterSummary({ageFilter,raceFilter,genderFilter,jobFilter,timeFilter,shiftFilter,workerFilter,locationFilter,hrFilter,companyFilter,costFilter,costNameFilter,backupFilter,veteranFilter,ethnicityFilter, employmentFilter, specialtyFilter, unitFilter, positionFilter, locFilter}, otherFilters);
    setSummary(summary);

    if (showSummaryEdit && !hasEdited)
      setTitle(summary);

  });

  const hasFilters = (key) => {
    //if key is empty check if any filters are present else check for filters by the key
    return !key && !_.isEmpty(summaryReport.filterValues) 
      ? _.find(Object.keys(summaryReport.filterValues), key => Array.isArray(summaryReport.filterValues[key]) && summaryReport.filterValues[key].length > 0)
      : !_.isEmpty(summaryReport.filterValues) && _.has(summaryReport.filterValues, key) && Array.isArray(summaryReport.filterValues[key]) && summaryReport.filterValues[key].length > 0;
  }


  const show = nav.settingsOpen;
  const isPulse = summaryReport.survey && summaryReport.survey.indexOf("Pulse") > -1;
  const { filters } = props;

  useEffect(() => {
    const arrayOfFilters = _.flatten(_.filter(filters, (value, key) => typeof value === 'object'))
    if (arrayOfFilters.length === 0) {
      clearFilters()
    };
  }, [JSON.stringify(filters)])

  const handleBenchmarkChange = useCallback(event => {
    const newBenchmark = event.target.value;
    dispatch(benchmarksOperations.applyBenchmark(newBenchmark));
    closeSettings();
  }, [closeSettings]);

  let benchmarksOptions = [];
  if (summaryReport.datasetId) {
    const workSettingBenchmarksArray = summaryReport.workSettingBenchmarks.split(',').map(str => str.trim());
    const datasetBenchmarksArray = summaryReport.datasetBenchmarks.split(',').map(str => str.trim());
    benchmarksOptions = unit === 'all' && !(Array.isArray(filters.unit) && filters.unit.length === 1) 
      ? datasetBenchmarksArray
      : workSettingBenchmarksArray;
    if (!appliedBenchmark || !_.includes(benchmarksOptions, appliedBenchmark)) {
      dispatch(benchmarksOperations.applyBenchmark(benchmarksOptions[0]));
    }
  } else {
    benchmarksOptions = [];
  }

  let benchmarkName = summaryReport.datasetUnitName || summaryReport.dataset_unit_name;
  if (!benchmarkName) {
    if (!summaryReport.unit && unit=='all') {
      benchmarkName = summaryReport.datasetEntityName || "Facility";
    } else {
      benchmarkName = "Work Setting";
    }
  }

  return (
    <Wrapper className={show ? "" : "hide"}>
      <div className="toggle" onClick={openSettings}>
        <Icon name="sliders" />
        <span>Settings</span>
      </div>
      <div className="sidebar-wrapper">
        <div className="sidebar">
          <IconButton icon="close" onClick={closeSettings} color="black" className="close-button" />
          <div className="header">Options</div>
          <div className="content">
            <div className="label">Key Drivers of Culture</div>
            <Checkbox
              label="Display negative and neutral values inline on donut graphs"
              checked={showInlineValuesOnDonuts}
              onChange={toggleShowInlineValuesOnDonuts}
            />
            {!isPulse && (
              <div>
                <div className="label">All Survey Items</div>
                <Checkbox label="Display results for ALL survey items" checked={showAllQuestions} onChange={toggleShowAllQuestions} />
                {showAllQuestions && (
                  <div>
                    <div style={{ paddingTop: "7px" }} />
                    <Checkbox
                      label="Display negative and neutral values inline on bar graphs"
                      checked={showAllQuestionInlineValues}
                      onChange={toggleShowAllQuestionInlineValues}
                    />
                  </div>
                )}
              </div>
            )}

            {hasFilters() && <div className="filters">
              <h3>Filters</h3>

              {showOtherFilters()}

              {!hasOtherFilters() && <div className="defaultFilters">
                {hasFilters('age_group') && <div className="label">Age</div>}
                {hasFilters('age_group') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setAgeFilter([...ageFilter, optionId])}
                  removeOption={(optionId) => setAgeFilter([...ageFilter.filter((id) => id !== optionId)])}
                  selectedIds={ageFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "age_group")}
                />}

                {hasFilters('race') && <div className="label">Race</div>}
                {hasFilters('race') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setRaceFilter([...raceFilter, optionId])}
                  removeOption={(optionId) => setRaceFilter([...raceFilter.filter((id) => id !== optionId)])}
                  selectedIds={raceFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "race")}
                />}

                {hasFilters('gender') && <div className="label">Gender</div>}
                {hasFilters('gender') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setGenderFilter([...genderFilter, optionId])}
                  removeOption={(optionId) => setGenderFilter([...genderFilter.filter((id) => id !== optionId)])}
                  selectedIds={genderFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "gender")}
                />}

                {hasFilters('job_family') && <div className="label">Job Family</div>}
                {hasFilters('job_family') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setJobFilter([...jobFilter, optionId])}
                  removeOption={(optionId) => setJobFilter([...jobFilter.filter((id) => id !== optionId)])}
                  selectedIds={jobFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "job_family")}
                />}

                {hasFilters('time_type') && <div className="label">Full/Part Time</div>}
                {hasFilters('time_type') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setTimeFilter([...timeFilter, optionId])}
                  removeOption={(optionId) => setTimeFilter([...timeFilter.filter((id) => id !== optionId)])}
                  selectedIds={timeFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "time_type")}
                />}

                {hasFilters('work_shift') && <div className="label">Work Shift</div>}
                {hasFilters('work_shift') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setShiftFilter([...shiftFilter, optionId])}
                  removeOption={(optionId) => setShiftFilter([...shiftFilter.filter((id) => id !== optionId)])}
                  selectedIds={shiftFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "work_shift")}
                />}

                {hasFilters('worker_sub_type') && <div className="label">Worker Sub Type</div>}
                {hasFilters('worker_sub_type') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setWorkerFilter([...workerFilter, optionId])}
                  removeOption={(optionId) => setWorkerFilter([...workerFilter.filter((id) => id !== optionId)])}
                  selectedIds={workerFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "worker_sub_type")}
                />}

                {hasFilters('location_hierarchy') && <div className="label">Location Hierarchy</div>}
                {hasFilters('location_hierarchy') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setLocationFilter([...locationFilter, optionId])}
                  removeOption={(optionId) => setLocationFilter([...locationFilter.filter((id) => id !== optionId)])}
                  selectedIds={locationFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "location_hierarchy")}
                />}

                {hasFilters('hr_company_name') && <div className="label">HR Company Name</div>}
                {hasFilters('hr_company_name') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setHrFilter([...hrFilter, optionId])}
                  removeOption={(optionId) => setHrFilter([...hrFilter.filter((id) => id !== optionId)])}
                  selectedIds={hrFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "hr_company_name")}
                />}

                {hasFilters('company') && <div className="label">Company</div>}
                {hasFilters('company') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setCompanyFilter([...companyFilter, optionId])}
                  removeOption={(optionId) => setCompanyFilter([...companyFilter.filter((id) => id !== optionId)])}
                  selectedIds={companyFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "company")}
                />}


                {hasFilters('cost_center') && <div className="label">Cost Center</div>}
                {hasFilters('cost_center') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setCostFilter([...costFilter, optionId])}
                  removeOption={(optionId) => setCostFilter([...costFilter.filter((id) => id !== optionId)])}
                  selectedIds={costFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "cost_center")}
                />}              


                {hasFilters('cost_center_name') && <div className="label">Cost Center Name</div>}
                {hasFilters('cost_center_name') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setCostNameFilter([...costNameFilter, optionId])}
                  removeOption={(optionId) => setCostNameFilter([...costNameFilter.filter((id) => id !== optionId)])}
                  selectedIds={costNameFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "cost_center_name")}
                />}

                {hasFilters('backup_unit') && <div className="label">Team Name</div>}
                {hasFilters('backup_unit') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setBackupFilter([...backupFilter, optionId])}
                  removeOption={(optionId) => setBackupFilter([...backupFilter.filter((id) => id !== optionId)])}
                  selectedIds={backupFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "backup_unit")}
                />}               

                {hasFilters('ethnicity') && <div className="label">Ethnicity</div>}
                {hasFilters('ethnicity') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setEthnicityFilter([...ethnicityFilter, optionId])}
                  removeOption={(optionId) => setEthnicityFilter([...ethnicityFilter.filter((id) => id !== optionId)])}
                  selectedIds={ethnicityFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "ethnicity")}
                />}    

                {hasFilters('veteran_status') && <div className="label">Veteran Status</div>}
                {hasFilters('veteran_status') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setVeteranFilter([...veteranFilter, optionId])}
                  removeOption={(optionId) => setVeteranFilter([...veteranFilter.filter((id) => id !== optionId)])}
                  selectedIds={veteranFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "veteran_status")}
                />}

                {hasFilters('employment') && <div className="label">Employment</div>}
                {hasFilters('employment') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setEmploymentFilter([...employmentFilter, optionId])}
                  removeOption={(optionId) => setEmploymentFilter([...employmentFilter.filter((id) => id !== optionId)])}
                  selectedIds={employmentFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "employment")}
                />}

                {hasFilters('physician_specialty') && <div className="label">Specialty</div>}
                {hasFilters('physician_specialty') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setspecialtyFilter([...specialtyFilter, optionId])}
                  removeOption={(optionId) => setspecialtyFilter([...specialtyFilter.filter((id) => id !== optionId)])}
                  selectedIds={specialtyFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "physician_specialty")}
                />}

                {hasFilters('location_description') && <div className="label">Location</div>}
                {hasFilters('location_description') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setLocFilter([...locFilter, optionId])}
                  removeOption={(optionId) => setLocFilter([...locFilter.filter((id) => id !== optionId)])}
                  selectedIds={locFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "location_description")}
                />}  
              </div>}            

              {unit === 'all' && hasFilters('unit') && <div className="label">Work Setting</div>}
                {unit === 'all' && hasFilters('unit') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setUnitFilter([...unitFilter, optionId])}
                  removeOption={(optionId) => setUnitFilter([...unitFilter.filter((id) => id !== optionId)])}
                  selectedIds={unitFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "unit")}
                />}

                {hasFilters('position') && <div className="label">Position</div>}
                {hasFilters('position') && <Select
                  multiple
                  chipLimit={1}
                  chipCharacterLimit={12}
                  addOption={(optionId) => setPositionFilter([...positionFilter, optionId])}
                  removeOption={(optionId) => setPositionFilter([...positionFilter.filter((id) => id !== optionId)])}
                  selectedIds={positionFilter}
                  selectableOptions={getFilterValues(summaryReport.filterValues, "position")}
                />}              

              <div className="label">
                Filter Display Text
                {showSummaryEdit && <button className="ui tertiary button editfilters" role="button" onClick={() => {setTitle('');setShowSummaryEdit(false)}}>Reset</button>}
                {!showSummaryEdit && summary!=='' && <button className="ui tertiary button editfilters" role="button" onClick={() => {setTitle(summary);setShowSummaryEdit(true)}}>Edit</button>}
              </div>
              {showSummaryEdit && <TextField 
                name="description" 
                margin="none"
                style={{backgroundColor:'#fff'}}
                variant="outlined"
                fullWidth
                multiline
                rowsMax={5}
                value={title}
                onFocus={ evt => evt.target.select()}
                onChange={evt => {
                  setHasEdited(true);
                  setTitle(evt.target.value);
                }}/>}

              {!showSummaryEdit &&<div className="filter-preview">
                {title || summary}
              </div>}

              <button className={clsx({ui:true, primary:true, button:true, loading:submitting})} onClick={applyFilters}>
                Apply Filters
              </button>

              <button className={clsx({ui:true, tertiary:true, button:true, clearfilters:true, available: filters.count >= 0 || anyFiltersSet()})} onClick={clearFilters}>Clear Filters</button>
            </div>}
            {benchmarksOptions && benchmarksOptions.length > 0 && (
              <BenchmarkContainer>
                <BenchmarkIcon/>
                <FormControl component="fieldset">
                  <TypographyParagraph className="label">{benchmarkName} Benchmark</TypographyParagraph>
                  <TypographyParagraph>Set the {benchmarkName && benchmarkName.toLowerCase()} benchmark for the report</TypographyParagraph>
                  <RadioGroup value={appliedBenchmark} onChange={handleBenchmarkChange}>
                    {benchmarksOptions.map((benchmark, i) => {
                      const trimmedBenchmark = benchmark.trim();
                      const benchmarkLabel = getBenchmarkLabel(benchmark);
                      return (
                        <FormControlLabel key={`${trimmedBenchmark}-${i}`} value={trimmedBenchmark} control={<Radio />} label={benchmarkLabel} checked={trimmedBenchmark === appliedBenchmark}/>
                      )
                    })}
                  </RadioGroup>
                </FormControl>
              </BenchmarkContainer>
            )}
            {/* {showAllQuestions && (
                <Checkbox
                  className="sub"
                  label="Display percentiles"
                  checked={showAllQuestionPercentiles}
                  onChange={toggleShowAllQuestionPercentiles}
                />
              )} */}
          </div>
        </div>
      </div>
      <FiltersErrorDialog open={showFiltersError} onClose={toggleShowFiltersError} />
    </Wrapper>
  );
}
export default connect((store) => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    nav: store.nav,
    filters: store.filters,
    appliedBenchmark: store.benchmarks.appliedBenchmark
  };
})(Sidebar);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Sidebar/index.jsx